import { jsx as r, jsxs as n } from "react/jsx-runtime";
import "../../../node_modules/@perxis-auto/shared/lib/lib/async/hooks/useAsync.js";
import "react";
import "../../../node_modules/markdown-it/lib/rules_core/state_core.js";
import "../../../node_modules/markdown-it/lib/rules_block/state_block.js";
import "../../../node_modules/markdown-it/lib/rules_block/html_block.js";
import "../../../node_modules/markdown-it/lib/rules_inline/state_inline.js";
import "../../../node_modules/markdown-it/lib/rules_inline/escape.js";
import { isDefined as d } from "../../../node_modules/@perxis-auto/shared/lib/lib/is/isDefined.js";
import { LoadingEnum as a } from "../../../node_modules/@perxis-auto/shared/lib/types/utility/async.js";
import { useCurrentStage as m, useStages as u } from "@perxis-auto/trade-in-sdk";
import { StageEntityId as g } from "@perxis-auto/trade-in-sdk/types";
import { Disclaimer as h } from "@perxis-auto/ui-kit";
import { Row as t, Col as e } from "@perxis-auto/ui-kit/lib/components/Grid";
import { Typography as o } from "@perxis-auto/ui-kit/lib/components/Typography";
import { STAGE_NUMBER_MAP as s, MAX_STAGE_NUMBER as _, STAGE_TITLE_MAP as f } from "../../../shared/config/stages.js";
import { Loader as v } from "../../../shared/ui/Loader/Loader.js";
import x from "./AppLayout.module.scss.js";
function b({ children: c }) {
  const { current: l } = m(), { service: i, loading: p } = u();
  return [a.Idle, a.Pending].includes(p) ? /* @__PURE__ */ r(t, { gutter: [0, "vertical-green"], className: x.loaderContainer, children: /* @__PURE__ */ r(e, { span: 24, children: /* @__PURE__ */ r(v, {}) }) }) : /* @__PURE__ */ n(t, { gutter: [0, "vertical-green"], children: [
    !!l && d(s[l]) && /* @__PURE__ */ r(e, { span: 24, className: "perxis-auto-trade-in-step", children: /* @__PURE__ */ n(o.Title, { className: "perxis-auto-trade-in-step__title", color: "darkest", level: "h4", children: [
      "Шаг ",
      s[l],
      " из ",
      _,
      ". ",
      f[l]
    ] }) }),
    /* @__PURE__ */ r(e, { span: 24, children: /* @__PURE__ */ n(t, { gutter: [0, "vertical-red"], children: [
      /* @__PURE__ */ r(e, { span: 24, children: c }),
      !!i && /* @__PURE__ */ r(e, { span: 24, className: "perxis-auto-trade-in-service", children: /* @__PURE__ */ n(t, { gutter: [0, "vertical-green"], children: [
        /* @__PURE__ */ n(t, { gutter: [0, "vertical-purple"], children: [
          i.description && /* @__PURE__ */ r(e, { span: 24, children: /* @__PURE__ */ r(
            o.Text,
            {
              className: "perxis-auto-trade-in-service__description",
              color: "dark-light",
              level: "small",
              children: /* @__PURE__ */ r("span", { dangerouslySetInnerHTML: { __html: i.description } })
            }
          ) }),
          !!i.logo_url && /* @__PURE__ */ r(e, { span: 24, children: /* @__PURE__ */ r(t, { gutter: [18, "vertical-purple"], children: /* @__PURE__ */ r(e, { children: /* @__PURE__ */ r("img", { src: i.logo_url, alt: i.id }) }) }) })
        ] }),
        l === g.SUCCESS && i.disclaimer_text && /* @__PURE__ */ r(e, { span: 24, children: /* @__PURE__ */ r(h, { children: /* @__PURE__ */ r(
          o.Text,
          {
            className: "perxis-auto-trade-in-service__disclaimer",
            color: "dark-light",
            level: "super-small",
            children: /* @__PURE__ */ r("span", { dangerouslySetInnerHTML: { __html: i.disclaimer_text.replace(">", ">*&nbsp;") } })
          }
        ) }) })
      ] }) })
    ] }) })
  ] });
}
export {
  b as AppLayout
};
